import { Images } from '@/assets/images';
import { TextMessage } from '@/constant';
import { dayjs, formatDate } from '@/utils';

import { FormConfig } from '../define-document-write.type';

const initializeValue = {
	acceptProInf: '',
	acceptProInfThirdParty: '',
	acceptProRegistDate: '',
	acceptProSignature: '',
	acceptProRegistName: '',
};

const ACCEPT_PRO_INF_OPTIONS = ['1', '0'];
const ACCEPT_PRO_INF_THIRD_PARTY_OPTIONS = ['1', '0'];

type IValues = typeof initializeValue;

export const CONSENT_TO_COLLECT_CONFIG: FormConfig<IValues> = {
	initializeValue,
	title: '개인정보 수집 및 이용 제공 동의',
	mapPropToValues: () => {
		return {
			acceptProRegistDate: formatDate(dayjs()),
		};
	},
	pages: [
		{
			background: {
				src: Images.formConsentToCollect,
				className: 'template',
				dataSource: Images.formConsentToCollect,
			},
			checkboxes: [
				{
					name: 'acceptProInf',
					classNames: [
						'absolute top-[528px] right-[222px] w-7 h-7',
						'absolute top-[513px] right-[155px] w-[60px] h-[60px]',
					],
					iconType: 'circle',
					options: ACCEPT_PRO_INF_OPTIONS,
				},

				{
					name: 'acceptProInfThirdParty',
					classNames: [
						'absolute top-[737px] right-[213px] w-7 h-7',
						'absolute top-[719px] right-[144px] w-[60px] h-[60px]',
					],
					iconType: 'circle',
					options: ACCEPT_PRO_INF_THIRD_PARTY_OPTIONS,
				},
			],
			datePickers: [
				{
					name: 'acceptProRegistDate',
					segmentedInputs: true,
					format: 'YYYY         MM         DD',
					containerClassName: 'absolute top-[817px] left-[301px] ',
					style: { fontSize: '14px' },
					boxStyle: { marginTop: '-7px' },
				},
			],
			signatures: [
				{
					name: 'acceptProRegistName',
					className: 'absolute top-[839px] left-[319px] w-[125px] h-[36px]',
				},
				{
					name: 'acceptProSignature',
					className: 'absolute top-[839px] left-[484px] w-[125px] h-[36px]',
				},
			],
			highlightBoxes: [
				(values, index) => ({
					name: 'acceptProInf',
					className: 'top-[534px] left-[90px] !h-[19px] w-[443px]',
					hasError: values?.acceptProInf !== ACCEPT_PRO_INF_OPTIONS[0],
				}),
				(values, index) => ({
					name: 'acceptProInfThirdParty',
					className: 'top-[742px] left-[90px] !h-[19px] w-[461px]',
					hasError:
						values?.acceptProInfThirdParty !==
						ACCEPT_PRO_INF_THIRD_PARTY_OPTIONS[0],
				}),
				{
					name: 'acceptProRegistDate',
					className: 'top-[810px] left-[338px] !h-[21px] w-[21px]',
				},
				{
					name: 'acceptProRegistDate',
					className: 'top-[810px] left-[387px] !h-[21px] w-[21px]',
				},
				{
					name: 'acceptProRegistDate',
					className: 'top-[810px] left-[434px] !h-[21px] w-[21px]',
				},
				{
					name: 'acceptProRegistName',
					className: 'top-[844px] left-[248px] !h-[21px] w-[73px]',
				},
				{
					name: 'acceptProSignature',
					className: 'top-[844px] left-[438px] !h-[21px] w-[108px]',
				},
			],
		},
	],
	validateOnSave: (data) => {
		const requiredFields = [
			'acceptProInf',
			'acceptProInfThirdParty',
			'acceptProRegistDate',
			'acceptProRegistName',
			'acceptProSignature',
		];

		const hasEmptyField = requiredFields.some(
			(field) => !data?.[field as keyof typeof data]
		);

		if (hasEmptyField) {
			return {
				hasError: true,
			};
		}

		if (
			data?.acceptProInf !== ACCEPT_PRO_INF_OPTIONS[0] ||
			data?.acceptProInfThirdParty !== ACCEPT_PRO_INF_THIRD_PARTY_OPTIONS[0]
		) {
			return {
				hasError: true,
				message: TextMessage.PRIVACY_CONSENT_REQUIRED,
			};
		}

		return {
			hasError: false,
		};
	},
};
